import {useMemo} from "react";
import {IStep} from "../../store/how-it-works/Helper";
import {useTranslation} from "react-i18next";

const useHowItWorksJsonLd = (steps: IStep[]) => {
    const {i18n, t} = useTranslation()

    const content = useMemo(() => (
        {
            "@context": "https://schema.org",
            "@type": "HowTo",
            "name": `${t('how_it_works')} - Genie`,
            "description": t('how_it_works_jsonld_description'),
            "url": `${window.location.href}/how-it-works`,
            "steps": steps.map((s) => ({
                "@type": "HowToStep",
                "name": s[`title_${i18n.language}`],
                "text": s[`subtitle_${i18n.language}`]
            }))
        }
    ), [steps, i18n.language, t])
    return {content}
}

export default useHowItWorksJsonLd
